import Grid from './Grid/Grid'
import withAEM from '../../../hoc/withAEM'

const ReactGrid = (props: any): JSX.Element => {
  const ReactGridWithAEM = withAEM(Grid)
  return <ReactGridWithAEM {...props} compName={'React Grid'} />
}
export default ReactGrid
